module.exports = __webpack_public_path__ + "img/favicon.d8c4df50.png";